import { createRpcClientV2 } from 'rpc-client-utils';
import appAuthApiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { connectRpc } from '../../../../../__generated__/chirp/com/hubspot/uber/conference/rpc/AccountRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: appAuthApiClient
});
const HUBSPOT_URL_APP = getFullUrl('app');
export function authorizeUberconference(args) {
  return rpcClient.call(connectRpc, {
    request: {
      baseRedirectUrl: HUBSPOT_URL_APP,
      oAuthCodeHolder: {
        code: args.code
      }
    }
  });
}